
import React from 'react';
import './ThermographyBenefits.css'; // Ensure your CSS is linked

const ThermographyBenefits = () => {
  return (
    <div className="thermography-page">
      <div className="thermography-container">
        <h1 className="text-center mb-4 montserrat-font">Benefits of Infrared</h1>
        <div className="thermal-line"></div>
        <p className="intro">
          Infrared, or thermal imaging, is a non-invasive and radiation-free diagnostic technique that captures heat patterns from the surface of the body. It is widely used in both medical and veterinary fields. Here are some key benefits:
        </p>

        <ul className="benefit-list">
          <li>
            <span className="benefit-icon">✅</span>
            Early detection of inflammation, infections, and circulatory issues.
          </li>
          <li>
            <span className="benefit-icon">✅</span>
            Useful in breast health monitoring without exposure to radiation.
          </li>
          <li>
            <span className="benefit-icon">✅</span>
            Identifies musculoskeletal injuries, nerve dysfunction, and soft tissue conditions.
          </li>
          <li>
            <span className="benefit-icon">✅</span>
            Helpful in veterinary care to detect lameness or inflammation in animals.
          </li>
          <li>
            <span className="benefit-icon">✅</span>
            Completely painless, contact-free, and safe for frequent use.
          </li>
          <li>
            <span className="benefit-icon">✅</span>
            Allows for ongoing monitoring of chronic conditions without side effects.
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ThermographyBenefits;
